// extracted by mini-css-extract-plugin
export default {"threeYrPlan":"CampaignDetails_threeYrPlan__OWFYX","threeYrPlanHD":"CampaignDetails_threeYrPlanHD__Q7RrJ"};